import { ChangeDetectorRef, Component, EventEmitter, HostListener, Input, OnDestroy, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatDialog, MatDialogContent, MatDialogActions } from '@angular/material/dialog';
import { MatTableDataSource, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { BehaviorSubject, combineLatest, Observable, Subject, takeUntil } from 'rxjs';
import { RegistationUtilitiesService } from 'src/app/modules/registration/services/registation-utilities.service';
import { ApiService } from 'src/app/services/apiService/api.service';
import { CamService } from 'src/app/services/camService/cam.service';
import { ComponentVisibilityService } from 'src/app/services/commonService/component-visibility.service';
import { AddPassportDetailsComponent } from '../add-passport-details/add-passport-details.component';
import { CryptoService } from 'src/app/services/commonService/crypto.service';
import { ToastrApiService } from 'src/app/shared/common/toastr-api.service';
import { CommonService } from 'src/app/shared/common/common.service';
import { EmailVerificationComponent } from 'src/app/modules/registration/components/email-verification/email-verification.component';
import { OtpRequestPayload } from 'src/app/models/interface/Registration/registration';
import { ContentService } from '../../services/content.service';
import { DisctionaryContent } from 'src/app/services/sitecoreDictionary/dictionary-content.service';
import { TravelerManagement } from 'src/app/services/dataLayer/CAM/traveler-management.service';
import { AccountService } from 'src/app/services/accountService/account.service';
import { environment } from 'src/environments/environment';
import { LinkAccountDialogComponent } from 'src/app/modules/registration/components/link-account-dialog/link-account-dialog.component';
import { NgIf, NgFor, NgSwitch, NgSwitchCase, DatePipe } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { NgSelectComponent, NgOptgroupTemplateDirective, NgOptionTemplateDirective, NgLabelTemplateDirective, NgNotFoundTemplateDirective } from '@ng-select/ng-select';
import { MatError, MatFormField, MatLabel, MatSuffix } from '@angular/material/form-field';
import { MatSelect } from '@angular/material/select';
import { MatOption } from '@angular/material/autocomplete';
import { MatInput } from '@angular/material/input';
import { DateOfbirthComponent } from '../date-ofbirth/date-ofbirth.component';
import { ExpiryDateComponent } from '../expiry-date/expiry-date.component';
import { MatButton } from '@angular/material/button';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { ApprovalContentService } from '../../services/approval-content.service';

export interface StateGroup {
  letter: string;
  names: {
    name: string;
    code: string;
    isdCode: string;
    countryFlag: string;
  }[];
}
export interface City {
  cityName: string;
  cityCode: string;
}
export interface PrecheckRow {
  tsaPrecheck: string;
  documentNumber: string;
}
@Component({
  selector: 'app-document-info-form',
  templateUrl: './document-info-form.component.html',
  styleUrls: ['./document-info-form.component.scss'],
  imports: [ReactiveFormsModule, NgIf, MatIcon, NgSelectComponent, NgOptgroupTemplateDirective, NgOptionTemplateDirective, NgLabelTemplateDirective, NgNotFoundTemplateDirective, MatError, MatFormField, MatLabel, MatSuffix, MatSelect, NgFor, MatOption, MatInput, NgSwitch, NgSwitchCase, DateOfbirthComponent, ExpiryDateComponent, MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow, MatButton, MatProgressSpinner, CdkScrollable, MatDialogContent, MatDialogActions, DatePipe]
})
export class DocumentInfoFormComponent implements OnInit, OnDestroy {
  public _siteCoreBaseUrl = environment.siteCoreBaseUrl;
  documentinfoForm: FormGroup;
  //editdocument: boolean = false;
  edit = false;
  private readonly baseColumns1: string[] = ['DocType', 'DocNo', 'dob', 'nationality', 'placeOfIssue', 'expiryDate'];
  isTAEditMode: boolean = true;
  get displayedColumns1(): string[] {
    return this.canShowDocumentActions
      ? [...this.baseColumns1, 'actions'] : this.baseColumns1;
  }
  get preCheckColumns(): string[] {
    return this.canShowDocumentActions
      ? ['tsaPrecheck', 'documentNumber', 'actions']
      : ['tsaPrecheck', 'documentNumber'];
  }
  get canShowDocumentActions(): boolean {
    return this.isTAEditMode
      && this.travelerGUID != null
      && this.loginUserGUID != null
      && this.travelerGUID === this.loginUserGUID;
  }
  dataSource1 = new MatTableDataSource([]);
  dataSourcePreCheck = new MatTableDataSource<any>([]);
  documentTypes: any[] = [
    { value: 'P', name: 'Passport' },
    { value: 'A', name: 'National ID' },
    { value: 'I', name: 'IQAMA Number' },
    { value: 'T', name: 'TSA Precheck / Known Traveler number' },
    { value: 'R', name: 'Redress number' }

  ];
  filteredDocumentTypes: any[] = [];

  documentTypesObj: any = {
    P: {
      heading: 'Passport Number',
      input: 'Enter Passport Number'
    },
    A: {
      heading: 'National ID',
      input: 'Enter National ID'
    },
    I: {
      heading: 'IQAMA Number',
      input: 'Enter IQAMA Number'
    },
    T: {
      heading: 'TSA Precheck / Known Traveler number',
      input: 'Enter TSA Precheck / Known Traveler number'
    },
    R: {
      heading: 'Redress number',
      input: 'Enter Redress number'
    }

  };
  selectedDOB: Date | null = null;
  selectedDOB0: Date | null = null;
  dateRanges: Record<string, { minDate: Date; maxDate: Date }> = {};
  dateRanges0: Record<string, { minDate: Date; maxDate: Date }> = {};
  isDisableDateOfBirth = false;
  isDisableDateOfBirth0 = false;
  Addnew: boolean = false;
  countriesLists: any;
  filteredCountries: any;
  stateGroupOptions: any;
  selectedCountry: string | null = null;
  selectedCountryCode: string | null = null;
  @Input() Nationality: string | null = null;
  @Input() Country: string | null = null;
  selectedCountry1: string | null = null;
  selectedCountryCode1: string | null = null;

  @Input() travelerCode: string | null = null;
  @Input() INFtravelerCode: any;

  countriesLists2: any;
  filteredCountries2: any;
  stateGroupOptions2: any;
  selectedCountry2: string | null = null;
  selectedCountryCode2: string | null = null;
  @Input() Nationality2: string | null = null;
  @Input() Country2: string | null = null;

  noDataPersonalInfo!: boolean

  countriesListsStreet: any;
  filteredCountriesStreet: any;
  NationalityOptions: Observable<StateGroup[]> = new BehaviorSubject<StateGroup[]>([]).asObservable();
  PreviousCountryCode: any;
  cityControlStreet = new FormControl('');
  filteredCitiesStreet: { cityName: string; cityCode: string }[] = [];
  selectedCity: City | null = null;
  PreviousCity: string = '';
  PreviousCityCode: string = '';
  noResultsFound = false;
  countryTableList: any

  selectedvalidatedate: Date | null = null;
  dateRanges1: Record<string, { minDate: Date; maxDate: Date }> = {};
  isDisableDateOfBirth1 = false;

  selectedExpiryDate: Date | null = null;
  dateRanges2: Record<string, { minDate: Date; maxDate: Date }> = {};
  isDisableDateOfBirth2 = false;

  Loader: any = {
    isSpinner: false,
    isEditableClicked: false
  }

  minDate: any = {
    year: null,
    month: null,
    date: null
  }
  maxDate: any = {
    year: null,
    month: null,
    date: null
  }

  userId: string = '';
  guid: string = '';
  userData: any[] = [];
  QueryNo: string = '';
  personalInfo: any = {};
  isElmVerified: boolean = false;
  private readonly elmVerifiedLockedFields = ['DOB'] as const;
  PassPrt: boolean = true;
  ExpDate: boolean = true;
  IsuCont: boolean = true;
  IDNUM: boolean = false;
  IdField: boolean = true;
  selectedExpiryDateDate: Date | null = null;
  selectedDocument: string = '';
  DocumentNumber: string = '';
  NatnllId: boolean = false;
  paxTitles: any[] = [];
  GCCID: boolean = false;
  firstName: string = '';
  lastName: string = '';
  docName: any;
  profileName: any;
  elmFirstName: string = '';
  elmLastName: string = '';
  @Input() PPREQ?: boolean;
  @Input() PPEXPREQ?: boolean;
  @Input() NTLREQ?: boolean;
  @Input() ISUCONTREQ?: boolean;

  @Output() fieldStatusChange: EventEmitter<any> = new EventEmitter(); // Emit the field status
  @ViewChild('selectionWarning') selectionWarning!: TemplateRef<any>;
  commonObjPipes: any = {
    countryControl: { pipe: [], all: [] },
    countryCode: { pipe: [{ id: 1, name: '' }], all: [] },
    cities: []
  }
  loginType: any
  private readonly destroy$ = new Subject<void>();
  content: any;
  loginUserGUID: any;
  travelerGUID: any;
  approvalContent: any;
  constructor(
    private readonly fb: FormBuilder,
    public visibilityService: ComponentVisibilityService,
    private readonly _CamApiService: CamService,
    public _CommonService: CommonService,
    public _ApiService: ApiService,
    private readonly cdr: ChangeDetectorRef,
    private readonly _ToastrApiService: ToastrApiService,
    private readonly _MatDialog: MatDialog,
    private readonly crypto: CryptoService,
    private readonly contentService: ContentService,
    private readonly dictionaryContentService: DisctionaryContent,
    private readonly travelerManagement: TravelerManagement,
    private readonly _AccountService: AccountService,
    private readonly _RegistationUtilitiesService: RegistationUtilitiesService,
    private approvalContentService: ApprovalContentService

  ) {
    this.documentinfoForm = this.fb.group({
      countryControl0: [null],
      placeOfResidence: [null],
      DocType: ['P', Validators.required],
      Passportno: [null],
      DOB: [null],
      issueCountry: [null],
      passportPOI: [null],
      Validfromdate: [null],
      ExpiryDate: [null,],
    });


    this.loginUserGUID = localStorage.getItem('userGuid')?.toLowerCase();
    this.travelerGUID = localStorage.getItem('travelerGUID')?.toLowerCase();
  }
  handleEvent(event: string) {
    if (!this.canShowDocumentActions) {
      return;
    }

    const LoginEmail = this.crypto.getValueFromKey('LOGINNAME') as string;
    const payload: OtpRequestPayload = {
      type: 'email',
      otpAction: "mobileOrEmailValidation",
      value: LoginEmail.toLowerCase(),
      channel: 'email',
      companyId: "SAA",
      b2BId: null,
      b2BUserId: null,
      eventName: "DocumentUpdate"
    };
    this.travelerManagement.document_click('document_add_click', 'Add');
    this._CamApiService.sendOTP(payload).then((res: any) => {
      const checksum = res.data.checksum
      this.Loader.isSpinner = false;
      const dialogRef = this._MatDialog.open(EmailVerificationComponent, {
        data: {
          data: this.documentinfoForm.value,
          Email: this.crypto.getValueFromKey('LOGINNAME')?.toLowerCase() as string,
          verifyMode: 'email',
          otpChecksum: checksum,
          actionType: 'DocumentAdd',
          panelClass: 'custom-passport-dialog'
        }
      })

      dialogRef.afterClosed().subscribe((result) => {
        if (result == 'verified') {
          this.Addnew = true;
          this.applyElmVerifiedFieldLocks();
        }
      });

    }).catch((error: any) => {

      const apiErrorCode = error?.error?.details?.[0]?.code;
      if (apiErrorCode === 'DUPLICATE_ENTRY') {
        this._ToastrApiService.show('error', 'OTP already sent. Please wait 30 seconds before trying again.')
      }
      this.Loader.isSpinner = false
      this._ToastrApiService.show('error', error?.error?.details?.[0]?.title)
    })



    if (event.includes('document-info')) {
      this.documentinfoForm.reset();
      this.documentinfoForm.get("DocType")?.setValue(this.filteredDocumentTypes[0]?.value);
      this.onDocTypeChange(this.filteredDocumentTypes[0]?.value);
      this.applyElmVerifiedFieldLocks();
    }
  }
  Cancel(): void {
    this.documentinfoForm.reset();
    this.Addnew = false;
    this.travelerManagement.traveler_detail_click('Cancel');
  }

  ngOnInit(): void {
    combineLatest({
      content: this.contentService.content$, dictionary: this.dictionaryContentService.content$
    }).pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      this.content = {
        ...res.content,
        dictionary: res.dictionary
      }
    });

    this.approvalContentService.content$.pipe(takeUntil(this.destroy$)).subscribe((res: any) => {
      this.approvalContent = res;
    });

    this.userId = sessionStorage.getItem('userId') || '';
    this.guid = sessionStorage.getItem('guid') || '';

    this._ApiService.getCountriesData().then(($res) => {
      this.countriesLists = this._CommonService.groupCountriesFilter($res);
    }).catch(($err) => { });
    if (this.userId && this.guid) {
      this.loadUserExecutiveData();
    } else {
      //this.editdocument = false;
      this.Loader.isEditableClicked = false;
    }
    this.noDataPersonalInfo = this._CommonService.getData('camSidebar')
    this.loginType = this.crypto.getValueFromKey('ISCORPTRAVELARRANGER') as string
    this.syncTAEditMode();

    const preCheckData: any[] = [
      { tsaPrecheck: 'TSA Precheck / Known Traveler number ', documentNumber: 'MH7015hLP' },
      { tsaPrecheck: 'Redress number', documentNumber: 'VH7015hLP' }
    ];
    this.dataSourcePreCheck.data = preCheckData;

    console.log(preCheckData);


    this.filteredDocumentTypes = [...this.documentTypes];

  }

  /** TA can edit only when opened profile SA_User_ID matches logged-in USERID. */
  private syncTAEditMode(): void {
    if (String(this.loginType) === '1') {
      const selectedUserId = String(this.userId || sessionStorage.getItem('userId') || '');
      const loggedInUserId = String(this.crypto.getValueFromKey('USERID') || '');
      this.isTAEditMode = !!loggedInUserId && selectedUserId === loggedInUserId;
    } else {
      this.isTAEditMode = true;
    }
  }

  private applyElmVerifiedFieldLocks(): void {
    if (!this.isElmVerified) {
      this.elmVerifiedLockedFields.forEach((field) => {
        this.documentinfoForm.get(field)?.enable({ emitEvent: false });
      });
      this.isDisableDateOfBirth0 = false;
      return;
    }

    this.bindPersonalDobForAdd();
    this.elmVerifiedLockedFields.forEach((field) => {
      this.documentinfoForm.get(field)?.disable({ emitEvent: false });
    });
    this.isDisableDateOfBirth0 = true;
    this.isChildVisible0['isDOBCalendarVisible0'] = false;
  }

  /** Add-document only: lock DOB to personalInfo.userDOB when ELM verified. */
  private bindPersonalDobForAdd(): void {
    if (!this.isElmVerified) {
      return;
    }
    const dobDate = this.parseDobToDate(this.personalInfo?.userDOB);
    if (!dobDate) {
      return;
    }
    this.selectedDOB0 = dobDate;
    this.documentinfoForm.get('DOB')?.setValue(this.formatDate(dobDate), { emitEvent: false });
  }

  private parseDobToDate(value: unknown): Date | null {
    if (!value) {
      return null;
    }
    if (value instanceof Date && !Number.isNaN(value.getTime())) {
      return value;
    }
    const raw = String(value).trim();
    if (!raw) {
      return null;
    }
    if (raw.includes('/')) {
      const parts = raw.split('/');
      if (parts.length === 3) {
        const day = Number(parts[0]);
        const month = Number(parts[1]);
        const year = Number(parts[2]);
        const parsed = new Date(year, month - 1, day);
        return Number.isNaN(parsed.getTime()) ? null : parsed;
      }
    }
    const parsed = new Date(raw);
    return Number.isNaN(parsed.getTime()) ? null : parsed;
  }

  private loadUserExecutiveData() {

    // this.editdocument = true;
    this.Loader.isEditableClicked = true;
    let payload = {
      "subagentId": this.crypto.getValueFromKey('SUBAGENTID') as string,
      "userRole": this.crypto.getValueFromKey('ISCORPTRAVELARRANGER') as string,
      B2BUserId: this.userId
    }
    this._CamApiService.PostUserExecutiveV1(this.guid, payload).then((response: any) => {
      if (response?.status === 'Success') {
        this.userData = response.data.documentInfo;
        this.personalInfo = response.data.personalInfo;
        this.isElmVerified = response.data.personalInfo?.isElmVerified || false;
        this.applyElmVerifiedFieldLocks();
        const PAIdocs = response.data.documentInfo.filter((doc: any) => ['P', 'A', 'I'].includes(doc.docType?.toUpperCase()))
        const TRdocs = response.data.documentInfo.filter((doc: any) => ['T', 'R'].includes(doc.docType?.toUpperCase()))
        this.dataSource1 = new MatTableDataSource(PAIdocs);
        this.dataSourcePreCheck = new MatTableDataSource(TRdocs)
        const userDataArray = response.data.documentInfo;
        this.prefillForm(userDataArray);

        this.filterDocumentTypesBasedOnExistingData();
      }
    }).catch((error: any) => {
      console.error('Error fetching Pax Titles:', error);
    });
  }

  getCountryNameByCode(code: string): string {
    const country = this.countriesLists?.find((c: { isoCode: string; }) => c.isoCode === code);
    return country ? country.countryName : code; // fallback to code if not found
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event): void {
    const clickedElement = event.target as HTMLElement;
    const clickedElement0 = event.target as HTMLElement;
    const isClickInside = clickedElement.closest('mat-form-field') || clickedElement.closest('.datepicker-content-container');
    const isClickInside0 = clickedElement0.closest('mat-form-field') || clickedElement0.closest('.datepicker-content-container');
    if (!isClickInside) {
      this.isChildVisible['isDOBCalendarVisible'] = false;
      this.isChildVisible0['isDOBCalendarVisible0'] = false;
      this.isChildVisible1['isDOBCalendarVisible1'] = false;
      this.isChildVisible2['isDOBCalendarVisible2'] = false;
      this.cdr.detectChanges();
    }
  }

  showComponent(componentKey: string): void {
    this.isChildVisible[componentKey] = true;
  }
  showComponent0(componentKey: string): void {
    if (this.isElmVerified) {
      return;
    }

    this.isChildVisible0[componentKey] = true;
    this.isChildVisible1['isDOBCalendarVisible1'] = false;
    this.isChildVisible2['isDOBCalendarVisible2'] = false;

    this.documentinfoForm.get('DOB')?.removeValidators([Validators.required])
    this.documentinfoForm.get('DOB')?.updateValueAndValidity()

  }
  showComponent1(componentKey: string): void {
    this.isChildVisible2['isDOBCalendarVisible2'] = false;
    this.isChildVisible0['isDOBCalendarVisible0'] = false;
    this.isChildVisible1[componentKey] = true;
    // this.documentinfoForm.get('Validfromdate')?.removeValidators([Validators.required])
    // this.documentinfoForm.get('Validfromdate')?.updateValueAndValidity()
  }
  showComponent2(componentKey: string): void {
    this.isChildVisible1['isDOBCalendarVisible1'] = false;
    this.isChildVisible0['isDOBCalendarVisible0'] = false;
    this.isChildVisible2[componentKey] = true;
    this.documentinfoForm.get('ExpiryDate')?.removeValidators([Validators.required])
    this.documentinfoForm.get('ExpiryDate')?.updateValueAndValidity()
  }
  isChildVisible: { [key: string]: boolean } = {
    isDOBCalendarVisible: false
  };
  isChildVisible0: { [key: string]: boolean } = {
    isDOBCalendarVisible0: false
  };
  isChildVisible1: { [key: string]: boolean } = {
    isDOBCalendarVisible1: false
  };
  isChildVisible2: { [key: string]: boolean } = {
    isDOBCalendarVisible2: false
  };

  onConfirm(componentKey: string) {
    this.hideComponent(componentKey);
  }
  onConfirm0(componentKey: string) {
    this.hideComponent0(componentKey);
  }
  onConfirm1(componentKey: string) {
    this.hideComponent1(componentKey);
  }
  onConfirm2(componentKey: string) {
    this.hideComponent2(componentKey);
  }
  hideComponent(componentKey: string): void {
    this.isChildVisible[componentKey] = false;
  }
  hideComponent0(componentKey: string): void {
    this.isChildVisible0[componentKey] = false;
  }
  hideComponent1(componentKey: string): void {
    this.isChildVisible1[componentKey] = false;
  }
  hideComponent2(componentKey: string): void {
    this.isChildVisible2[componentKey] = false;
  }
  onDateSelected(event: any): void {
    if (event.isCalenderShow === true) {
      this.selectedDOB = event.date;
      const formattedDate = this.formatDate(this.selectedDOB);
      this.documentinfoForm.get('dateofbirth')?.setValue(formattedDate);
      this.isChildVisible['isDOBCalendarVisible'] = false;
    }
  }
  onDateSelected0(event: any): void {
    if (event.isCalenderShow === true) {
      this.selectedDOB0 = event.date;
      const formattedDate = this.formatDate(this.selectedDOB0);
      this.documentinfoForm.get('DOB')?.setValue(formattedDate);
      this.isChildVisible0['isDOBCalendarVisible0'] = false;
      this.documentinfoForm.get('Validfromdate')?.reset()
    }
  }

  onDateSelected1(event: any): void {
    if (event.isCalenderShow === true) {
      this.selectedvalidatedate = event.date;
      const formattedDate = this.formatDate(this.selectedvalidatedate);
      this.documentinfoForm.get('Validfromdate')?.setValue(formattedDate);
      this.isChildVisible1['isDOBCalendarVisible1'] = false;
    }
  }

  onDateSelected2(event: { type: string; date: Date | null }, key: string): void {
    if (event.type === 'dob') {
      if (!event.date || event.date.toDateString() === new Date(0).toDateString()) {
        return;
      }
      this.selectedExpiryDate = event.date;
      const formattedDate = this.formatDate(this.selectedExpiryDate);
      this.documentinfoForm.get('ExpiryDate')?.setValue(formattedDate);
      this.isChildVisible2[key] = false;
    }
  }
  private formatDate(date: Date | null): string {
    if (!date) return '';
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  pasteControlHTMLTags(event: ClipboardEvent): void {
    const pastedData = event.clipboardData?.getData('text/plain') || '';
    if (!/^[0-9\-\/]+$/.test(pastedData)) {
      event.preventDefault();
    }
  }

  blockInvalidCharacters(event: KeyboardEvent): void {
    const invalidChars = ['<', '>', '"', "'", '`', ';', '--', '\\', '?', '+', '_', '#', '%', '^', '*', '!', '=', '%', '(', ')', '{', '}', '$', '~', '@', '&', '/', '.', ','];
    if (invalidChars.includes(event.key)) {
      event.preventDefault();
    }
  }

  onPasteBlocked(event: ClipboardEvent): void {
    event.preventDefault();
  }
  disableRightClick(event: MouseEvent): void {
    event.preventDefault();
  }

  formatDateToISOString(dateStr: string): string {

    if (dateStr === null) {
      return '';
    }
    const parts = dateStr.split('/').map(Number);
    if (parts.length !== 3 || parts.some(isNaN)) {
      throw new Error(`Invalid date format: ${dateStr}`);
    }
    const [day, month, year] = parts;
    if (day < 1 || day > 31 || month < 1 || month > 12 || year < 1000) {
      throw new Error(`Invalid date values: ${dateStr}`);
    }
    const date = new Date(Date.UTC(year, month - 1, day));
    if (isNaN(date.getTime())) {
      throw new Error(`Invalid date object created from: ${dateStr}`);
    }
    return date.toISOString();
  }

  onSave() {

    const docType = this.documentinfoForm.get('DocType')?.value;

    this.travelerManagement.traveler_detail_click('Save');
    this.Loader.isSpinner = true;
    if (this.documentinfoForm.invalid) {
      this._ToastrApiService.show('error', 'Please correct the form errors before submission.');
      this.Loader.isSpinner = false;
      return;
    }

    if (docType === 'P') {

      console.log(this.documentinfoForm.value)
      this.fetchMatchProfileApi('save')
      // this.verifyELM('nn');
      return; // ❌ stop normal save
    }

    if (docType === 'A' || docType === 'I') {

      console.log(this.documentinfoForm.value)
      // this.fetchMatchProfileApi()
      this.verifyELM('nn');
      return; // ❌ stop normal save
    }


    if (docType === 'T' || docType === 'R') {
      this.saveDocumentTR()
      return; // ❌ stop normal save
    }


  }
  deleteThisCard(PassportID: any) {
    this.travelerManagement.document_click('document_remove_click', 'Remove');
    this.travelerManagement.document_remove('Remove');
    this._CamApiService.deleteDocument(PassportID)
      .then(($res: any) => {
        if ($res?.status === 'Success') {
          this.travelerManagement.document_remove_success('Success');
          this._ToastrApiService.show("success", "Document deleted successfully.")
          this.Addnew = false;
          this.loadUserExecutiveData();

        }
        else {
          this._ToastrApiService.show("error", "Failed to delete data.")
        }
      })
      .catch(($err: any) => {
        console.error('Error on delete Card Details:', $err);
      });
  }
  prefillForm(userData: any[]): void {
    if (userData && userData.length > 0) {
      this.documentinfoForm.patchValue({
        countryControl0: this.userData[0].nationality,
        DocType: this.userData[0].docType
      });
    }
    this.cdr.detectChanges();
  }
  openDialog(): void {
    this.edit = false;
    const dialogRef = this._MatDialog.open(AddPassportDetailsComponent, {
      panelClass: 'seatSelectorPopup',
      width: '800px',
      height: '400px',

      data: { edit: this.edit, personalInfo: this.personalInfo }
    });
    dialogRef.afterClosed().subscribe((res: any) => {
      if (!!res?.data) {
      }
    });
  }

  openPassportDetails(element: any): void {
    this.travelerManagement.document_click('document_edit_click', 'Edit');
    const LoginEmail = this.crypto.getValueFromKey('LOGINNAME') as string;
    const payload: OtpRequestPayload = {
      type: 'email',
      otpAction: "mobileOrEmailValidation",
      value: LoginEmail.toLowerCase(),
      channel: 'email',
      companyId: "SAA",
      b2BId: null,
      b2BUserId: null,
      eventName: "DocumentUpdate"
    };

    this._CamApiService.sendOTP(payload).then((res: any) => {
      const checksum = res.data.checksum
      this.Loader.isSpinner = false;
      this._MatDialog.open(EmailVerificationComponent, {
        data: {
          data: this.documentinfoForm.getRawValue(),
          Email: this.crypto.getValueFromKey('LOGINNAME')?.toLowerCase() as string,
          verifyMode: 'email',
          otpChecksum: checksum,
          actionType: 'DocumentUpdate',
          element,
          edit: this.edit,
          personalInfo: this.personalInfo,
          panelClass: 'custom-passport-dialog'
        }
      })
    }).catch((error: any) => {
      console.log(error)

      const apiErrorCode = error?.error?.details?.[0]?.code;
      if (apiErrorCode === 'DUPLICATE_ENTRY') {
        this._ToastrApiService.show('error', 'OTP already sent. Please wait 30 seconds before trying again.')
      }
      this.Loader.isSpinner = false
      this._ToastrApiService.show('error', error?.error?.details?.[0]?.title)

    })


  }

  formatDateToCustomFormat(inputDate: string): string {
    const date = new Date(inputDate);
    const day = date.getDate();
    const month = date.toLocaleString('default', { month: 'short' });
    const year = date.getFullYear();
    return `${day} ${month} ${year}`;
  }

  changeCountry(event: any, setNull: boolean = true) {
    this.commonObjPipes.cities = [];
    if (setNull) {
      this.documentinfoForm.get('passportPOI')?.setValue(null);
    }
    if (!!event?.isoCode || !!event) {
      this._ApiService.GetCities(event?.isoCode ?? event, '').then(({ data: $cities }) => {
        this.commonObjPipes.cities = $cities;
      })
    }

  }

  selectFirstOption() {
    if (this.countriesLists?.length > 0) {
      this.documentinfoForm.get('countryControl0')?.setValue(this.countriesLists[0].isoCode);
    }
  }



  onDocTypeChange(docType: string) {
    this.elmFirstName = '';
    this.elmLastName = '';

    const form = this.documentinfoForm;
    const country = form.get('countryControl0');
    const residence = form.get('placeOfResidence');
    const passportNo = form.get('Passportno');
    const dob = form.get('DOB');
    const issueCountry = form.get('issueCountry');
    const poi = form.get('passportPOI');
    const expiry = form.get('ExpiryDate');
    const validFrom = form.get('Validfromdate');

    // 🔄 First clear all validators
    Object.keys(form.controls).forEach(key => {
      form.get(key)?.clearValidators();
      form.get(key)?.updateValueAndValidity({ emitEvent: false });
    });

    if (docType === 'T' || docType === 'R') {

      // ✅ Required only these 4
      country?.setValidators([Validators.required]);
      residence?.setValidators([Validators.required]);
      passportNo?.setValidators([
        Validators.required,
        docType === 'T'
          ? Validators.pattern(/^\d{9}$/)
          : Validators.pattern(/^\d{7}$/)
      ]);

    } else if (docType === 'P' || docType === 'A' || docType === 'I') {

      // ✅ Required fields
      country?.setValidators([Validators.required]);
      residence?.setValidators([Validators.required]);
      dob?.setValidators([Validators.required]);
      issueCountry?.setValidators([Validators.required]);
      poi?.setValidators([Validators.required]);
      expiry?.setValidators([Validators.required]);

      // ❌ Validfromdate is optional (no validator)

      // Passport / ID validation
      switch (docType) {

        case 'P':
          passportNo?.setValidators([
            Validators.required,
            Validators.pattern(/^[a-zA-Z0-9]{6,12}$/)
          ]);
          break;

        case 'A':
          passportNo?.setValidators([
            Validators.required,
            Validators.pattern(/^1\d{9}$/)
          ]);
          break;

        case 'I':
          passportNo?.setValidators([
            Validators.required,
            Validators.pattern(/^2\d{9}$/)
          ]);
          break;
      }
    }

    // 🔥 Update all controls
    Object.keys(form.controls).forEach(key => {
      form.get(key)?.updateValueAndValidity();
    });
    this.applyElmVerifiedFieldLocks();
  }



  get isPrecheckOrRedress(): boolean {

    const type = this.documentinfoForm.get('DocType')?.value;
    return type === 'T' || type === 'R';
  }




  filterDocumentTypesBasedOnExistingData(): void {
    const existingDocTypes = this.userData.map(
      (doc: any) => doc.docType?.toUpperCase()
    );

    this.filteredDocumentTypes = this.documentTypes.filter(type => {

      // ❌ Remove already existing types
      if (existingDocTypes.includes(type.value)) {
        return false;
      }

      // 🔥 Simple check → if A or I exists, remove both A & I
      if (
        (existingDocTypes.includes('A') || existingDocTypes.includes('I')) &&
        (type.value === 'A' || type.value === 'I')
      ) {
        return false;
      }

      return true;
    });

  }
  convertToISODate(dob: string): string {
    if (!dob) return '';
    // Split the date into day, month, and year
    const dateParts = dob.split('/');
    // If the format is correct, return the date in the desired format (YYYY-MM-DD)
    if (dateParts.length === 3) {
      const day = dateParts[0];
      const month = dateParts[1];
      const year = dateParts[2];
      // Ensure the month and day are zero-padded to 2 digits
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    }
    return dob; // If the format is incorrect, return the original string
  }

  getImageUrl(path: string): string {
    if (!path) return '';

    const base = this._siteCoreBaseUrl?.replace(/\/+$/, '') || '';
    const cleanPath = path.replace(/^\/+/, '');

    return `${base}/${cleanPath}`;
  }

  verifyELM(_: any): void {
    this.firstName = this.crypto.getValueFromKey("USERFNAME") as string;
    this.lastName = this.crypto.getValueFromKey("USERLNAME") as string;
    const payload = this.buildELMPayload();

    if (!payload) return;

    this._AccountService.VerifyELMV1(payload).subscribe(
      (response) => {
        console.log(response)
        this.Loader.isSpinner = false;
        this.documentinfoForm.get('Passportno')?.setErrors(null);

        this.elmFirstName = response?.data?.firstName || '';
        this.elmLastName = response?.data?.lastName || '';
        const firstname = this.elmFirstName;
        const lastname = this.elmLastName;
        //    const firstname = 'Mantosh';
        // const lastname = 'Yadav';
        this.docName = firstname + ' ' + lastname;
        this.profileName = this.firstName + ' ' + this.lastName;
        if (this.docName.toUpperCase().trim() != this.profileName.toUpperCase().trim()) {
          this._MatDialog.open(this.selectionWarning, {
            data: {}
          })
        } else {
          this.fetchMatchProfileApi('continue');
        }


      },
      (error) => {
        console.log(error)
        const control = this.documentinfoForm.get('Passportno');

        control?.setErrors({
          ...control.errors,
          apiError: error?.error?.message || 'Verification failed'
        });
        control?.markAsTouched();

      },

    );
  }

  private buildELMPayload(): any | null {
    const dob = this.documentinfoForm.get('DOB')?.value;
    const identity = this.documentinfoForm.get('Passportno')?.value;
    const nationality = this.documentinfoForm.get('countryControl0')?.value;
    const docType = this.documentinfoForm.get('DocType')?.value;
    if (!dob || !identity) return null;
    const formattedDob = this.convertToISODate(dob);
    switch (docType) {
      case 'A':
        return {
          nationalID: identity,
          nationality: nationality,
          dateOfBirth: formattedDob,
        };
      case 'I':
        return {
          iqama: identity,
          dateOfBirth: formattedDob,
        };
      default:
        return null; // passport → no ELM call
    }
  }




  CloseDialog(status: boolean) {
    if (!status) {
      this._MatDialog.closeAll()
    }
  }



  fetchMatchProfileApi(flag: 'save' | 'continue' = 'save') {

    const sessionID = localStorage.getItem('session_id');
    const token = localStorage.getItem('access_token');
    const firstName = this.crypto.getValueFromKey("USERFNAME") as string;
    const lastName = this.crypto.getValueFromKey("USERLNAME") as string;
    const contactID = this.personalInfo?.contactId;
    const customerType = this.personalInfo?.customerTypes;
    const formData = this.documentinfoForm.getRawValue()

    const matchPayload = {
      id: formData?.Passportno,
      IDtype: this.getDocumentType(formData?.DocType),
      nationality: formData?.countryControl0,

      matchPreferences: {
        isProfileUpdate: true,
        sourceProfile: `[${customerType.join(', ')}]`,
        contactId: contactID
      }
    };

    this._RegistationUtilitiesService
      .fetchMatching(sessionID, token, matchPayload)
      .subscribe((res: any) => {
        const hasMatch =
          Array.isArray(res?.data?.matchedContacts) &&
          res?.data?.matchedContacts.length > 0;

        if (hasMatch) {
          // this.dialogRef.close();
          this._MatDialog.open(LinkAccountDialogComponent, {
            disableClose: true,
            data: {
              docDetail: this.personalInfo,
              matches: res.data,
              fullName: `${firstName} ${lastName}`,
              data: this.documentinfoForm.getRawValue(),
              method: 'documentInfoAdd',
              elmVerificationDate: new Date(),
              isELMVerified: true,
              docname: this.docName

            },
          });
        } else {
          if (flag === 'save') {
            this.savePassport()
          } else {
            this.saveDocNationalIqama()
          }
        }
      });
  }

  getDocumentType(type: string): string {
    const map: any = {
      P: 'passport',
      A: 'nationalid',
      I: 'iqama'
    };

    return map[type?.toUpperCase()] || '';
  }


  saveDocumentTR() {

    console.log(this.personalInfo)
    const accountID = localStorage.getItem('additionalRefNo')
    const payload = {
      queryNo: 2,
      passportID: 0,
      passportNationality: this.documentinfoForm.get('countryControl0')?.value,
      countryOfResidence: this.documentinfoForm.get('placeOfResidence')?.value,
      DocumentType: this.documentinfoForm.get('DocType')?.value,
      passportNumber: this.documentinfoForm.get('Passportno')?.value,
      passportDOB: this.formatDateToISOString(this.documentinfoForm.get('DOB')?.value) || null,
      passportCountryCode: this.documentinfoForm.get('issueCountry')?.value || null,
      passportPOI: this.documentinfoForm.get('passportPOI')?.value || null,
      passportValidityStartDate: this.documentinfoForm.get('Validfromdate')?.value
        ? this.formatDateToISOString(this.documentinfoForm.get('Validfromdate')?.value)
        : null,

      PassportExpiryDate: this.formatDateToISOString(this.documentinfoForm.get('ExpiryDate')?.value) || null,
      isPrimary: true,
      contactId: this.personalInfo?.contactId || null,
      accountID: accountID,
      // email: this.personalInfo?.email || null,
      ciamId: this.personalInfo?.ciamId || null,
      firstName: this.personalInfo?.firstName,
      lastName: this.personalInfo?.lastName
    };
    console.log("Payload",)
    this.userId = sessionStorage.getItem("userId") || "";
    this._CamApiService.UpdateDocumentDetails(this.userId, payload).then(response => {
      this._ToastrApiService.show('success', "Document information Insert successfully.")
      this._CommonService.formResetTrigger(); //to reset the form

      this.loadUserExecutiveData();
      if (this.edit) {
        this.travelerManagement.document_click('document_edit_save', 'Save');
      } else {
        this.travelerManagement.document_click('document_save_success', 'Success');
      }
      setTimeout(() => {
        this.Loader.isSpinner = false;
        this.Loader.isEditableClicked = true;
        this.Addnew = false

      }, 2000)
    })
      .catch(error => {
        console.error("Error saving data", error);
        this._ToastrApiService.show('error', error.error.message)
        this._CommonService.formResetTrigger(); //to reset the form

      });
  }


  savePassport() {

    console.log(this.personalInfo)
    const accountID = localStorage.getItem('additionalRefNo')
    const payload = {
      queryNo: 2,
      passportID: 0,
      passportNationality: this.documentinfoForm.get('countryControl0')?.value,
      countryOfResidence: this.documentinfoForm.get('placeOfResidence')?.value,
      DocumentType: this.documentinfoForm.get('DocType')?.value,
      passportNumber: this.documentinfoForm.get('Passportno')?.value,
      passportDOB: this.formatDateToISOString(this.documentinfoForm.get('DOB')?.value) || null,
      passportCountryCode: this.documentinfoForm.get('issueCountry')?.value || null,
      passportPOI: this.documentinfoForm.get('passportPOI')?.value || null,
      passportValidityStartDate: this.documentinfoForm.get('Validfromdate')?.value
        ? this.formatDateToISOString(this.documentinfoForm.get('Validfromdate')?.value)
        : null,

      PassportExpiryDate: this.formatDateToISOString(this.documentinfoForm.get('ExpiryDate')?.value) || null,
      isPrimary: true,
      secondaryContactId: this.personalInfo?.contactId || null,
      primaryContactId: null,
      accountID: accountID,
      // email: this.personalInfo?.email || null,
      ciamId: this.personalInfo?.ciamId || null,
      firstName: this.personalInfo?.firstName,
      lastName: this.personalInfo?.lastName,
      isELMVerified: false,
      elmVerificationDate: null,
      otp: null,
      checksum: null,
      type: null,
      value: null,
      otpAction: null,
      consentMerge: false
    };
    console.log("Payload",)
    this.userId = sessionStorage.getItem("userId") || "";
    this._CamApiService.UpdateDocumentDetails(this.userId, payload).then(response => {
      this._ToastrApiService.show('success', "Document information Insert successfully.")
      this._CommonService.formResetTrigger(); //to reset the form

      this.loadUserExecutiveData();
      if (this.edit) {
        this.travelerManagement.document_click('document_edit_save', 'Save');
      } else {
        this.travelerManagement.document_click('document_save_success', 'Success');
      }
      setTimeout(() => {
        this.Loader.isSpinner = false;
        this.Loader.isEditableClicked = true;
        this.Addnew = false

      }, 2000)
    })
      .catch(error => {
        console.error("Error saving data", error);
        this._ToastrApiService.show('error', error.error.message)
        this._CommonService.formResetTrigger(); //to reset the form

      });
  }

  saveDocNationalIqama() {

    console.log(this.personalInfo)
    const accountID = localStorage.getItem('additionalRefNo')
    const payload = {
      queryNo: 2,
      passportID: 0,
      passportNationality: this.documentinfoForm.get('countryControl0')?.value,
      countryOfResidence: this.documentinfoForm.get('placeOfResidence')?.value,
      DocumentType: this.documentinfoForm.get('DocType')?.value,
      passportNumber: this.documentinfoForm.get('Passportno')?.value,
      passportDOB: this.formatDateToISOString(this.documentinfoForm.get('DOB')?.value) || null,
      passportCountryCode: this.documentinfoForm.get('issueCountry')?.value || null,
      passportPOI: this.documentinfoForm.get('passportPOI')?.value || null,
      passportValidityStartDate: this.documentinfoForm.get('Validfromdate')?.value
        ? this.formatDateToISOString(this.documentinfoForm.get('Validfromdate')?.value)
        : null,

      PassportExpiryDate: this.formatDateToISOString(this.documentinfoForm.get('ExpiryDate')?.value) || null,
      isPrimary: true,
      secondaryContactId: this.personalInfo?.contactId || null,
      primaryContactId: null,
      accountID: accountID,
      // email: this.personalInfo?.email || null,
      ciamId: this.personalInfo?.ciamId || null,
      firstName: this.elmFirstName ? this.elmFirstName : this.personalInfo?.firstName,
      lastName: this.elmLastName ? this.elmLastName : this.personalInfo?.lastName,
      isELMVerified: true,
      elmVerificationDate: new Date(),
      otp: null,
      checksum: null,
      type: null,
      value: null,
      otpAction: null,
      consentMerge: false
    };
    console.log("Payload",)
    this.userId = sessionStorage.getItem("userId") || "";
    this._CamApiService.UpdateDocumentDetails(this.userId, payload).then(response => {
      this._ToastrApiService.show('success', "Document information Insert successfully.")
      this._CommonService.formResetTrigger(); //to reset the form

      this.loadUserExecutiveData();
      if (this.edit) {
        this.travelerManagement.document_click('document_edit_save', 'Save');
      } else {
        this.travelerManagement.document_click('document_save_success', 'Success');
      }
      setTimeout(() => {
        this.Loader.isSpinner = false;
        this.Loader.isEditableClicked = true;
        this.Addnew = false

      }, 2000)
    })
      .catch(error => {
        console.error("Error saving data", error);

        let msg = error?.error?.message || error?.message || "Error saving data";
        try {
          const parsedMsg = JSON.parse(error?.error?.message);
          msg = parsedMsg?.details?.[0]?.message?.message || parsedMsg?.details?.[0]?.message?.Message || msg;
          if (parsedMsg?.target) {
            msg = `${parsedMsg?.message || msg} - Target: ${parsedMsg?.target}`;
          }
        } catch (e) { }

        this._ToastrApiService.show('error', msg);
        this._CommonService.formResetTrigger(); //to reset the form
      });
  }


  onContinueAfterMismatch() {

    this._MatDialog.closeAll(); // popup close

    const docType = this.documentinfoForm.get('DocType')?.value;
    console.log(docType)
    // 👉 A / I ke case me fetchMatching call karna hai
    if (docType === 'A' || docType === 'I') {
      this.fetchMatchProfileApi('continue');
    }
  }

  verifyDuplicateDocID() {
    const passportControl = this.documentinfoForm.get('Passportno');

    const passportNo = passportControl?.value?.trim();

    // Passport number empty hai to API call nahi hogi
    if (!passportNo) {
      return;
    }


    const payload = {
      documentNumber: passportControl?.value,
      b2BUserId: sessionStorage.getItem('userId')
    };

    this._CamApiService.checkDuplicateDocuments(payload).then((res: any) => {
      if (res?.data === false) {
        passportControl?.setErrors({
          ...(passportControl.errors || {}),
          duplicatedoc: true
        });
      } else {
        if (passportControl?.hasError('duplicatedoc')) {
          const errors = { ...(passportControl.errors || {}) };
          delete errors['duplicatedoc'];

          passportControl.setErrors(
            Object.keys(errors).length ? errors : null
          );
        }
      }
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
